export default __webpack_public_path__ + "static/media/ic-irr-micro.0eddcf3e.svg";